import { useEffect, useState } from "react";
import { TransactionPdfData, TransactionsGeneratePdf } from "../pdf/transactions-pdf";
import { pdf } from "@react-pdf/renderer";
import { PDFViewer } from "../../../shared/pdf-viewer";
import { Button, Modal } from "antd";

interface AdhocTransaction {
    id: string;
    amount: number;
    reason: string;
    status: string;
    transactionReference: {
        referenceId: string;
    };
}

interface PaymentCompletedFormProps {
    adhocTransactionId: string;
    amount: number;
    adhocTransactions: AdhocTransaction[];
}

export const PaymentCompletedForm: React.FC<PaymentCompletedFormProps> = (props) => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedTransaction, setSelectedTransaction] = useState<AdhocTransaction|undefined>(undefined);
    const [pdfBlob, setPdfBlob] = useState<Blob | null>(null);

    useEffect(() => {
        const generatePdf = async () => {
            if (selectedTransaction) {
            const transactionData: TransactionPdfData = {
                tableData: selectedTransaction,
                amountLabel: "Amount Paid:"
            };
            try {
                // Generate the PDF asynchronously and set the blob state
                const blob = await pdf(
                <TransactionsGeneratePdf data={transactionData}/>
                ).toBlob();
                console.log("Generated PDF Blob:", blob);
                setPdfBlob(blob);
            } catch (error) {
                console.error("Error generating PDF:", error);
            }
            }
        };

        generatePdf();
    }, [selectedTransaction]);

  const showModal = (
    transaction: AdhocTransaction,
  ) => {
    const filterData = props?.adhocTransactions.find((item: AdhocTransaction) => item.id === props.adhocTransactionId);
    if (filterData) {
      setSelectedTransaction({
        ...filterData,
        id: transaction.id,
      });
    } else {
      setSelectedTransaction(undefined);
    }
    setIsModalVisible(true);
  };

    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedTransaction(undefined);
        setPdfBlob(null);
      };


    return (
        <div
            style={{
            backgroundColor: "white",
            paddingTop: "20px",
            paddingBottom: "20px",
            paddingLeft: "20px",
            paddingRight: "20px",
            margin: 10,
            textAlign: "left",
            border: "1px solid #d9d9d9",
            borderRadius: "8px",
            }}
        >
            <div >
  <p>Your credit card was charged successfully. You can view and download your receipt.To view all your transactions, use the Transactions tab above. </p>
  <div className="flex flex-col md:flex-row items-center md:items-start w-full rounded-lg overflow-auto bg-neutral-50	shadow-sm">
  <div className="w-full bg-[#dbffc5] text-black text-wrap rounded-lg h-[100%] ">
  <p className="h-full overflow-auto m-4" style={{ fontWeight: "bold" }}>US${props.amount} Sent Successfully</p>
    </div>
    <div className="flex items-center justify-center h-[100%]">
      <Button className="m-2 " onClick={() => showModal(props.adhocTransactions.find((item: AdhocTransaction) => item.id === props.adhocTransactionId) ?? {} as AdhocTransaction)}>
        View Receipt
      </Button>
    </div>
  </div>
  {isModalVisible && (
    <Modal
      title={`Staff - ${selectedTransaction?.transactionReference?.referenceId}.pdf`}
      width="fit-content"
      open={isModalVisible}
      closable
      footer={[
        <Button key="close" onClick={handleCancel}>
          Close
        </Button>
      ]}
      onCancel={handleCancel}
      destroyOnClose
    >
      {pdfBlob ? (
        <PDFViewer filename={`Staff - ${selectedTransaction?.transactionReference?.referenceId}.pdf`} docId="" blobPromise={Promise.resolve(pdfBlob)}></PDFViewer>
      ) : (
        <p>Loading PDF...</p>
      )}
    </Modal>
  )}
</div>
        </div>
    );
}